import { Suggestion } from 'types/suggestions';
import { getSRPSuggestionUrl, patchUrlByLocale } from 'utils';
import { capitalize } from 'utils/capitalize';

export const getHistoryItemTitle = (value: string, suggestion: Suggestion | null) => {
  if (!suggestion) {
    return value;
  }
  if ('categoryName' in suggestion && suggestion.categoryName) {
    return capitalize(suggestion.categoryName);
  }
  if ('name' in suggestion && suggestion.name) {
    return suggestion.name;
  }
  return value;
};

export const getHistoryItemUrl = (
  sanitizedValue: string,
  suggestion: Suggestion | null,
  searchHref: string,
) => {
  if (!suggestion) {
    return getSRPSuggestionUrl(searchHref, sanitizedValue, false);
  }
  if ('categoryUrl' in suggestion && suggestion.categoryUrl && 'categoryName' in suggestion) {
    return patchUrlByLocale({ url: suggestion.categoryUrl });
  }
  if ('pageUrl' in suggestion && suggestion.pageUrl) {
    return patchUrlByLocale({ url: suggestion.pageUrl });
  }
  return getSRPSuggestionUrl(searchHref, sanitizedValue);
};
